/* If you edit this file, please remove this header and clean up the resulting eslint errors.
 */
/* eslint-disable no-bitwise */
const NONE = 1;
const NOTICE = NONE << 1;
const INFO = NOTICE << 1;
const WARN = INFO << 1;
const ERROR = WARN << 1;
const VERBOSE = ERROR << 1;

const ALL = NONE | INFO | NOTICE | WARN | ERROR | VERBOSE;
const PRODUCTION = NONE | WARN | ERROR;
const STAGING = NOTICE | INFO | PRODUCTION;
const DEVELOPMENT = ALL;

function fromString(level) {
  return level
    .toUpperCase()
    .split('|')
    .map((name) => {
      return LogLevels[name] || NONE;
    })
    .reduce((a, b) => {
      return a | b;
    });
}

const LogLevels = {
  NONE,
  NOTICE,
  INFO,
  WARN,
  ERROR,
  VERBOSE,
  ALL,
  PRODUCTION,
  STAGING,
  DEVELOPMENT,
  fromString,
};

export {
  NONE,
  NOTICE,
  INFO,
  WARN,
  ERROR,
  VERBOSE,
  ALL,
  PRODUCTION,
  STAGING,
  DEVELOPMENT,
  fromString,
};

export default LogLevels;
